// クラシック版のグラデーションのバー（段階 C の2 の 2b。2026-10-25 に chibi.js の setGradBar から描き直した。見た目・動きは前と同じ）。
// バーの絵と上・下のつまみ（loadsvg.php の switch/bt_gradientbar.svg・bt_colorselect.svg）を #chaSvgGrad に置き、つまみは押すと選ぶ・縦に引っぱるとバーの中の色を選ぶ。
// 引っぱる動き（d3.drag と同じ。引っぱったあとのクリックは止まる）は fx の窓口から
import { chibi, common } from './engine.js';
import { appendSvg, bindData, onClick, svgEl } from './dom.js';
import * as fx from './fx.js';
import type { Selection } from './selection.js';

interface Scale {
  x(v: number): number;
  y(v: number): number;
}
interface GradEngine {
  PATH_IMG: string;
  ATTR_GRAD_BAR: string;
  ATTR_GRAD_FROM: string;
  ATTR_GRAD_TO: string;
  DIV_F_GRAD: string;
  SVG_GRAD: string;
  URI_LOADSVG: string;
  SIZE_COLOR_BAR_W: number;
  SIZE_COLOR_BAR_H: number;
  SIZE_COLOR_PT_W: number;
  SIZE_COLOR_PT_H: number;
  scGrad: Scale;
  svgGrad: Selection;
  setGradFromTo(sel: string, on?: boolean): void;
  setAllGradColor(from: string, to: string): void;
}
const E = (): GradEngine => chibi() as unknown as GradEngine;
type Common = {
  postJSON(url: string, param: Record<string, unknown>): Promise<unknown>;
  getAllGfromSVG(svgText: string): ArrayLike<Element>;
  convToHexRgb(c: string): string;
};
const C = (): Common => common() as unknown as Common;

/** グラデーションのバーを作る（引数は前のエンジンの名残で使わない） */
export function setGradBar(): void {
  const e = E();
  const barMin = 0;
  const barMax = e.SIZE_COLOR_BAR_H - e.SIZE_COLOR_PT_H;
  // [絵, id, x, y, 幅, 高さ, つまみの縦の位置]
  const gradbtn: [string, string, number, number, number, number, number][] = [
    [e.PATH_IMG + 'switch/bt_gradientbar.svg', e.ATTR_GRAD_BAR, 0, 0, e.SIZE_COLOR_BAR_W, e.SIZE_COLOR_BAR_H, 0],
    [e.PATH_IMG + 'switch/bt_colorselect.svg', e.ATTR_GRAD_FROM, e.scGrad.x(e.SIZE_COLOR_BAR_W), 0, e.SIZE_COLOR_PT_W, e.SIZE_COLOR_PT_H, barMin],
    [e.PATH_IMG + 'switch/bt_colorselect.svg', e.ATTR_GRAD_TO, e.scGrad.x(e.SIZE_COLOR_BAR_W), 0, e.SIZE_COLOR_PT_W, e.SIZE_COLOR_PT_H, barMax],
  ];
  const xmgn = (fx.width(e.DIV_F_GRAD) - e.scGrad.x(e.SIZE_COLOR_BAR_W + e.SIZE_COLOR_PT_W)) / 1;
  const ymgn = (fx.height(e.DIV_F_GRAD) - e.scGrad.y(e.SIZE_COLOR_BAR_H)) / 3;
  const svg = appendSvg(e.DIV_F_GRAD, e.SVG_GRAD, fx.width(e.DIV_F_GRAD), fx.height(e.DIV_F_GRAD));
  e.svgGrad = fx.d3Select(svg);
  if (svg) svg.setAttribute('display', 'none');
  // 絵は JSON で読む（読めなかったら何もしない＝前と同じ）
  C().postJSON(e.URI_LOADSVG, { files: gradbtn.map((d) => d[0]) }).then((data) => {
    if (data == null || !svg) return;
    const texts = data as string[];
    gradbtn.forEach((d, i) => {
      const g = svgEl('g', { id: d[1] });
      g.style.setProperty('cursor', i == 1 || i == 2 ? 'pointer' : 'default');
      g.setAttribute('transform', 'translate(' + (d[2] + xmgn) + ', ' + (d[3] + ymgn) + '), scale(' + E().scGrad.x(d[4]) / d[4] + ',' + E().scGrad.y(d[5]) / d[5] + ')');
      bindData(g, d);
      svg.appendChild(g);
      const inner = C().getAllGfromSVG(texts[i])[0];
      if (!inner) return;
      g.appendChild(inner);
      bindData(inner, d);
      // 初めの位置（つまみは上・下の端）
      inner.setAttribute('transform', i == 1 || i == 2 ? 'translate(0, ' + d[6] + ')' : 'translate(0, 0)');
      onClick(inner, () => {
        if (i == 1 || i == 2) E().setGradFromTo('#' + gradbtn[i][1]);
      });
      fx.dragY(inner, (dy) => {
        if (i != 1 && i != 2) return;
        d[6] = Math.min(barMax, Math.max(d[6] + dy, barMin));
        inner.setAttribute('transform', 'translate(0, ' + d[6] + ')');
        // バーの中の位置の色を、上・下のつまみの色からとって付ける
        const cfrom = C().convToHexRgb(fx.d3Select('#' + E().ATTR_GRAD_FROM + ' rect').style('fill'));
        const cto = C().convToHexRgb(fx.d3Select('#' + E().ATTR_GRAD_TO + ' rect').style('fill'));
        const colors = fx.interpolateRgb(cfrom, cto);
        E().setAllGradColor(C().convToHexRgb(colors(gradbtn[1][6] / barMax)), C().convToHexRgb(colors(gradbtn[2][6] / barMax)));
      });
    });
  });
}
